/**
 * `EX-TAG01` (ADR-0087): a tag's topic page and its name.
 *
 * A topic's address is its tag in URL form: lower-cased, each run of
 * whitespace one hyphen, the backend's `tag-slug.ts` rule, so an older tag
 * written with spaces ("shortest path") and a newer one ("shortest-path") are
 * one page. Its name comes from `judge.topics.<slug>.name`, our own list of
 * the common topics (English words in both catalogues, like the band names);
 * a tag outside the list prints as written.
 */
/** The library's page size, here so the server can ask for the same first page the client shows. */
export const LIBRARY_PAGE_SIZE = 20;

export function topicSlug(tag: string): string {
  return tag.trim().toLowerCase().replace(/\s+/g, "-");
}

export function topicHref(locale: string, tag: string): string {
  return `/${locale}/judge/problems/tag/${encodeURIComponent(topicSlug(tag))}`;
}

/** The part of a `judge.topics` translator this needs, server or client. */
type TopicTranslator = {
  (key: string): string;
  has: (key: string) => boolean;
};

/** The topic's name from the list, or the tag as written. */
export function topicName(t: TopicTranslator, tag: string): string {
  const key = `${topicSlug(tag)}.name`;
  return t.has(key) ? t(key) : tag;
}

/** The topic's one-line introduction from the list, or `null` outside it. */
export function topicIntro(t: TopicTranslator, tag: string): string | null {
  const key = `${topicSlug(tag)}.intro`;
  return t.has(key) ? t(key) : null;
}
